module.exports = __webpack_public_path__ + "img/6.87ab5bf9.jpg";